/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Upgrade_StudentInputs */

const en_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Student`)
};

const de_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Student upgraden`)
};

const fr_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à Étudiant`)
};

const es_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar a Estudiante`)
};

const it_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a Studente`)
};

const nl_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade naar Student`)
};

const pl_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź na Student`)
};

const fi_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä Opiskelija`)
};

const da_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader til Student`)
};

const sv_settings_upgrade_student = /** @type {(inputs: Settings_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera till Student`)
};

/**
* | output |
* | --- |
* | "Upgrade to Student" |
*
* @param {Settings_Upgrade_StudentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_upgrade_student = /** @type {((inputs?: Settings_Upgrade_StudentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Upgrade_StudentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_upgrade_student(inputs)
	if (locale === "fr") return fr_settings_upgrade_student(inputs)
	if (locale === "es") return es_settings_upgrade_student(inputs)
	if (locale === "it") return it_settings_upgrade_student(inputs)
	if (locale === "nl") return nl_settings_upgrade_student(inputs)
	if (locale === "pl") return pl_settings_upgrade_student(inputs)
	if (locale === "fi") return fi_settings_upgrade_student(inputs)
	if (locale === "da") return da_settings_upgrade_student(inputs)
	if (locale === "sv") return sv_settings_upgrade_student(inputs)
	return en_settings_upgrade_student(inputs)
});